import { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import CheckboxCell from "../../../common/interactive/CheckboxCell"
import DefaultUpdater from "../../../common/DefaultUpdater"
import { caseActions } from "../../../../store/case"
import { notificationActions } from "../../../../store/notifications"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { isCasePI } from "../../../../lib/script"
import { frontendOptions, shouldShowFieldUpdateLoader } from "../../../../lib/systemData"
import { HIOFDownload } from "./HIOFDownload"

import classes from './MajorMedNoItems.module.css'

export default function MajorMedNoItems({ permissionType }) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    const caseData = activeCase?.case ?? {}

    const [savingByField, setSavingByField] = useState({})
    const seqByFieldRef = useRef(new Map())

    const showApiLoader = shouldShowFieldUpdateLoader()

    if (!isCasePI(activeCase)) {
        return null
    }

    const updatehandler = async (value) => {
        if (!activeCase?.case?.id) {
            return
        }

        const caseId = activeCase.case.id
        const field = value?.identifier?.field
        if (!field) {
            return
        }

        const prevValue = caseData[field]
        const nextSeq = (seqByFieldRef.current.get(field) ?? 0) + 1
        seqByFieldRef.current.set(field, nextSeq)

        setSavingByField(prev => ({ ...prev, [field]: true }))

        dispatch(caseActions.modifyActiveCaseMultipleObject({
            folder: value.identifier.folder,
            item: {
                fields: [
                    {
                        field: value.identifier.field,
                        value: value.data.value,
                    },
                ],
            },
        }))

        const body = {
            type: value.identifier.type,
            fields: {
                [value.identifier.field]: value.data.value
            }
        }

        let update
        try {
            update = await caseQuickUpdate(userToken, caseId, body, dispatch, null, {
                staleGuardKey: `${caseId}:case:${field}`,
                staleGuardSequence: nextSeq,
            })
        } finally {
            if ((seqByFieldRef.current.get(field) ?? 0) === nextSeq) {
                setSavingByField(prev => ({ ...prev, [field]: false }))
            }
        }

        if (update?.staleResponse) {
            return
        }

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
            if ((seqByFieldRef.current.get(field) ?? 0) === nextSeq) {
                dispatch(caseActions.modifyActiveCaseMultipleObject({
                    folder: value.identifier.folder,
                    item: {
                        fields: [
                            {
                                field: value.identifier.field,
                                value: prevValue,
                            },
                        ],
                    },
                }))
            }
        }
    }

    return <div className={classes.container}>
        <HIOFDownload />

        <div className={classes.hiof_row}>
            <h3 className={classes.hiof_title}>HIOF</h3>
            <div className={classes.hiof_checkboxes}>
                <CheckboxCell
                    label={'Presented'}
                    checked={caseData.hiof_presented}
                    direction={'reverse'}
                    action={updatehandler}
                    identifier={{ type: 'case', field: 'hiof_presented', type_id: null, folder: 'case', permissionType: permissionType }}
                    apiDisabled={Boolean(savingByField.hiof_presented)}
                    showApiLoader={showApiLoader}
                />
                <CheckboxCell
                    label={'Recieved'}
                    checked={caseData.hiof_received}
                    direction={'reverse'}
                    action={updatehandler}
                    identifier={{ type: 'case', field: 'hiof_received', type_id: null, folder: 'case', permissionType: permissionType }}
                    apiDisabled={Boolean(savingByField.hiof_received)}
                    showApiLoader={showApiLoader}
                />
            </div>
        </div>

        <div className={classes.hiof_selected}>
            <h3 className={classes.hiof_title}>HIOF Selected</h3>
            <DefaultUpdater
                type={'radio'}
                value={caseData.hiof_selected}
                options={frontendOptions()?.HIOF_Selected_Options}
                name={'hiof_selected'}
                identifier={{ type: 'case', field: 'hiof_selected', type_id: null, folder: 'case', permissionType: permissionType }}
                extraOptions={{ normalSize: true }}
            />
        </div>

        <div className={classes.no_longer_billing}>
            <CheckboxCell
                label={'No Longer Billing'}
                checked={caseData.mm_no_longer_billing}
                direction={'reverse'}
                action={updatehandler}
                identifier={{ type: 'case', field: 'mm_no_longer_billing', type_id: null, folder: 'case', permissionType: permissionType }}
                apiDisabled={Boolean(savingByField.mm_no_longer_billing)}
                showApiLoader={showApiLoader}
            />
        </div>
    </div>
}
